import React from "react";

const withDonation = Component => {
  return class DonationPage extends React.Component {
    render() {
      return <Component getDonateCategory={true} {...this.props} />;
    }
  };
};

export default withDonation;



// WEBPACK FOOTER //
// ./components/donations/withDonation.js